import { Image, message, Tag } from "antd";
import axios from "axios";
import { create } from "zustand";
import { MAIN_URL } from "../../../Constants";
export const useBTSConfigs = create((set, get) => ({
    ed: null,
    setEd: (ed) => set({ ed }),
    columns: [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
            width: 100,
        },
        {
            title: 'Rasmi',
            dataIndex: 'img',
            key: 'img',
            width: 100,
            render: (text, record) => {
                return (
                    <div>
                        <Image
                            width={80}
                            src={MAIN_URL + '/' + record.img}
                        />
                    </div>
                )
            }
        },
        {
            title: 'Nomi',
            dataIndex: 'product_name',
            key: 'product_name',
            width: 300,
            render: (text, record) => {
                return (
                    <div>
                        <b>Nomi:</b> {record.product_name}
                        <br />
                        <b>Kategoriyasi:</b> {record.category_name}
                        <br />
                        <b>Qo'shimcha parametr:</b> {record.parametr}
                        <br />
                        <b>Davlat:</b> {record.country_name}
                        <br />
                        <b>Ishlab chiqaruvchi:</b> {record.manufacturer_name}
                    </div>
                )
            }
        },
        {
            title: 'Model',
            dataIndex: 'models',
            key: 'models',
            render: (text, record) => {
                return (
                    <div>
                        <b>Modellar:</b> {record.models.map(m => <Tag color='blue' key={m.id}>{m.nameuz}</Tag>)}
                        <br />
                        <b>Markalar:</b> {record.brands.map(m => <Tag color='green' key={m.id}>{m.nameuz}</Tag>)}
                    </div>
                )
            }
        },
        {
            title: 'BTS Config',
            dataIndex: 'weight_id',
            key: 'weight_id',
            render: (text, record) => {
                return (
                    <div>
                        <b>Og'irligi:</b> <Tag color='blue'>{record.volume}</Tag>
                        <br />
                        <b>Gabariti:</b> <Tag color='blue'>{record.weight}</Tag>
                        <br />
                        <b>Qadoq turi:</b> <Tag color='blue'>{record.packageId}</Tag>
                        <br />
                        <b>Shakli:</b> <Tag color='blue'>{record.postTypeId}</Tag>
                    </div>
                )
            }
        }
    ],
    data: [],
    getBTSConfigs: () => {
        axios.get('/vr_weights').then(res => {
            set({ data: res.data.sort((a, b) => a.id - b.id) })
        })
    },

    packages: [],
    post_types: [],

    getPackages: () => {
        axios.get('/getpackageId').then(res => {
            set({ packages: res.data })
        })
    },

    getPostTypes: () => {
        axios.get('/getpostTypeId').then(res => {
            set({ post_types: res.data })
        })
    },


    updateBTSConfig: (data) => {
        axios.put('/updateweight/' + data.id, data).then(res => {
            message.success('BTS Config edited successfully')
            get().getBTSConfigs()
            get().setOpen(false)
            get().setEditOpen(false)
        }).catch(err => {
            message.error('BTS Config edited failed')
        })
    }




}))

